import { ReactElement, ReactNode } from 'react';
import clsx from 'clsx';
import Card from '@components/Card';
import IconButton from '@components/IconButton';
import Icon from '@components/Icon';

interface HomePageCardProps {
  children: ReactNode;
  className?: string;
  subTitle?: string;
  title: string;
  onBack?: () => void;
}

function HomePageCard({
  children,
  className,
  subTitle,
  title,
  onBack,
}: HomePageCardProps): ReactElement {
  return (
    <Card
      className={clsx('relative max-w-[643px]', className)}
      transparentOnMobile
    >
      {onBack && (
        <IconButton className="absolute top-[36px] left-2" onClick={onBack}>
          <Icon.ArrowPrevious className="text-iconMedium text-white" />
        </IconButton>
      )}
      <div className="mx-auto mb-2 text-center">
        <h1 className="text-heading4 text-white font-semibold">{title}</h1>
      </div>
      {subTitle && (
        <div className="mx-auto mb-2 text-center">
          <h2 className="text-heading6 text-white">{subTitle}</h2>
        </div>
      )}
      {children}
    </Card>
  );
}

export default HomePageCard;
